import Translation from "./Translation";

const TRANSLATIONS_JP = {
  Translation,
};
export default TRANSLATIONS_JP;
